// AppDataApi.js
// This is the API module for calling intial app load data for projects, units, employees, employee positions, other items can be added, but the main endpoint here is api/db/

import axios from "axios";
import { getCsrfToken, setupCsrfInterceptor } from "../auth/csrfUtils";

// Create axios instance with default config
const api = axios.create({
  baseURL: "/api",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  // Session cookies are required for this API
  withCredentials: true,
});

// Setup CSRF protection for this API instance
setupCsrfInterceptor(api);

// App Data endpoint
const baseAppDataUrl = "/db";

// Get all projects
export const getAllProjects = async () => {
  try {
    const response = await api.get(`${baseAppDataUrl}/all_project_info`);
    if (response.data && response.data.db_project_info) {
      return response.data.db_project_info;
    } else {
      throw new Error("Invalid data format received from server");
    }
  } catch (error) {
    console.error("Error fetching projects:", error);
    throw error;
  }
};

// Get all inactive projects
export const getAllInactiveProjects = async () => {
  try {
    const response = await api.get(
      `${baseAppDataUrl}/all_inactive_project_info`
    );
    if (response.data && response.data.db_inactive_project_info) {
      return response.data.db_inactive_project_info;
    } else {
      throw new Error("Invalid data format received from server");
    }
  } catch (error) {
    console.error("Error fetching inactive projects:", error);
    throw error;
  }
};

// Get all units
export const getAllUnits = async () => {
  try {
    const response = await api.get(`${baseAppDataUrl}/all_units`);
    if (response.data && response.data.units) {
      return response.data.units;
    } else {
      throw new Error("Invalid data format received from server");
    }
  } catch (error) {
    console.error("Error fetching units:", error);
    throw error;
  }
};

// Get all employees
export const getAllEmployees = async () => {
  try {
    const response = await api.get(`${baseAppDataUrl}/all_employees`);
    if (response.data && response.data.employees) {
      return response.data.employees;
    } else {
      throw new Error("Invalid data format received from server");
    }
  } catch (error) {
    console.error("Error fetching employees:", error);
    throw error;
  }
};

// Get all terminated employees
export const getAllTerminatedEmployees = async () => {
  try {
    const response = await api.get(
      `${baseAppDataUrl}/all_terminated_employees`
    );
    if (response.data && response.data.terminated_employees) {
      return response.data.terminated_employees;
    } else {
      throw new Error("Invalid data format received from server");
    }
  } catch (error) {
    console.error("Error fetching terminated employees:", error);
    throw error;
  }
};

// Get all employee positions
export const getAllEmployeePositions = async () => {
  try {
    const response = await api.get(`${baseAppDataUrl}/all_employee_positions`);
    if (response.data && response.data.employee_positions) {
      return response.data.employee_positions;
    } else {
      throw new Error("Invalid data format received from server");
    }
  } catch (error) {
    console.error("Error fetching employee positions:", error);
    throw error;
  }
};
